export enum ElementType {
  String = 'STRING',
  Number = 'NUMBER',
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Enum = 'ENUM',
}
